import {Action, combineReducers} from "redux";

import {reduceRequestState, reduceResponseField, RequestState} from "@pg-mono/request-state";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {fetchOfferDetailPropertiesTypes, PropertyListTabTypes} from "../actions/fetch_offer_detail_properties";
import {OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE} from "../constants/offer_detail_properties";

interface ISinglePropertiesStore {
    properties: IPropertyListProperty[];
    requestState: RequestState;
    page: number;
    count: number;
    pageSize: number;
}

export interface IOfferPropertiesStore {
    filter: ISinglePropertiesStore;
    investment: ISinglePropertiesStore;
    modal: ISinglePropertiesStore;
    activeTab: "filter" | "investment" | "modal";
}

/**
 * Active tab reducer - tracks which tab is currently active
 */
const activeTabReducer = (state: PropertyListTabTypes = PropertyListTabTypes.FILTER, action: Action): PropertyListTabTypes => {
    if (action.type === fetchOfferDetailPropertiesTypes.filter.start) {
        return PropertyListTabTypes.FILTER;
    }
    if (action.type === fetchOfferDetailPropertiesTypes.investment.start) {
        return PropertyListTabTypes.INVESTMENT;
    }
    if (action.type === fetchOfferDetailPropertiesTypes.modal.start) {
        return PropertyListTabTypes.MODAL;
    }
    return state;
};

/**
 * Reducers
 */
export const offerDetailPropertiesReducer = combineReducers({
    filter: combineReducers({
        properties: reduceResponseField<IPropertyListProperty[]>(fetchOfferDetailPropertiesTypes.filter, "properties", []),
        requestState: reduceRequestState(fetchOfferDetailPropertiesTypes.filter),
        page: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.filter, "page", 1),
        count: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.filter, "count", 0),
        pageSize: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.filter, "page_size", OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE)
    }),
    investment: combineReducers({
        properties: reduceResponseField<IPropertyListProperty[]>(fetchOfferDetailPropertiesTypes.investment, "properties", []),
        requestState: reduceRequestState(fetchOfferDetailPropertiesTypes.investment),
        page: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.investment, "page", 1),
        count: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.investment, "count", 0),
        pageSize: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.investment, "page_size", OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE)
    }),
    modal: combineReducers({
        properties: reduceResponseField<IPropertyListProperty[]>(fetchOfferDetailPropertiesTypes.modal, "properties", []),
        requestState: reduceRequestState(fetchOfferDetailPropertiesTypes.modal),
        page: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.modal, "page", 1),
        count: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.modal, "count", 0),
        pageSize: reduceResponseField<number>(fetchOfferDetailPropertiesTypes.modal, "page_size", OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE)
    }),
    activeTab: activeTabReducer
});
